import script from "./RoutingAddressesLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoutingAddressesLoading.vue?vue&type=script&setup=true&lang=ts"

import "./RoutingAddressesLoading.vue?vue&type=style&index=0&id=6a81c012&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a81c012"]])

export default __exports__